/**
 * 路由配置文件
 * 包含公开路由和受保护路由的定义
 */

// 定义公开路由（无需登录即可访问）
export const publicRoutes: string[] = ['/login', '/errors/404', '/errors/500'];

// 定义受保护路由（需要登录才能访问）
export const protectedRoutes: string[] = [
    '/',
    '/control-panel/*',
    '/permissions/*',
    '/products/*',
    '/materials/*',
    '/sales/*',
    '/users/*',
    '/inventories/*',
    '/shipment-requests/*',
    '/shipped-packages/*',
    '/refunds/*',
    '/finances/*',
    '/works/*',
    '/dashboards',
    '/material-purchase-orders/*',
    '/errors/401',
    '/errors/403',
];
